import Head from 'next/head';
import { FC, useContext } from 'react';

import { GlobalContext } from '@/pages/_app';

const Seo: FC<any> = ({
	url,
	title,
	description,
	imageUrl,
	postImage,
	authorName,
	dateModified,
	datePublished,
}) => {
	const { lang } = useContext(GlobalContext);

	return (
		<Head>
			<title>{title}</title>

			<meta name="description" content={description} />

			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta
				property="og:image"
				content={postImage ? postImage : '/images/LinkPreview.png'}
			/>

			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:site" content="@viberforbusiness" />
			<meta
				name="twitter:image"
				content={
					postImage
						? postImage
						: 'https://env-stage-hosting.s3.eu-central-1.amazonaws.com/Link_Preview_38306795db.png'
				}
			/>

			{url ? (
				<>
					<link
						rel="canonical"
						href={`https://www.forbusiness.viber.com/${lang}${url}`}
					/>

					<link
						rel="alternate"
						href={`https://www.forbusiness.viber.com/en${url}`}
						hrefLang="en"
					/>

					<link
						rel="alternate"
						href={`https://www.forbusiness.viber.com/ru${url}`}
						hrefLang="ru"
					/>

					<link
						rel="alternate"
						href={`https://www.forbusiness.viber.com/ua${url}`}
						hrefLang="ua"
					/>
				</>
			) : null}

			{imageUrl && authorName ? (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							'@context': 'https://schema.org',
							'@type': 'BlogPosting',
							mainEntityOfPage: {
								'@type': 'WebPage',
								'@id': 'Article URL',
							},
							headline: `${title}`,
							description: `${description}`,
							image: `${imageUrl}`,
							author: {
								'@type': 'Person',
								name: `${authorName}`,
							},
							publisher: {
								'@type': 'Organization',
								name: 'Viber',
								logo: {
									'@type': 'ImageObject',
									url: 'https://www.forbusiness.viber.com/images/logo/logo-main.svg',
									width: '140.79px',
									height: '24.56px',
								},
							},
							dateModified,
							datePublished,
						}),
					}}
				/>
			) : null}

			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'Organization',
						name: 'Viber',
						url: 'https://www.forbusiness.viber.com',
						sameAs: [
							'https://twitter.com/viber4business',
							'https://facebook.com/viber4business',
							'https://instagram.com/viber4business',
							'https://linkedin.com/company/1710293/admin',
						],
					}),
				}}
			/>
		</Head>
	);
};

export default Seo;
